import React from 'react'
import { ResultDisplayProps } from '../../common'
import { DefaultResultDisplay } from '../../DefaultDisplay/DefaultResultDisplay'
import { CUSTOM_PRESET_MAPPING } from '../../../CustomPresets/CustomPresetMapping'
import { ErrorBoundary } from 'react-error-boundary'

export const ResultDisplay: React.FC<ResultDisplayProps> = (props) => {
  const {
    aiFeature: { preset: { id: presetId } = {} },
  } = props

  if (!presetId) {
    return null
  }

  const ResultDisplayElement = CUSTOM_PRESET_MAPPING[presetId]?.display ?? DefaultResultDisplay

  return (
    <div className='d-flex flex-column w-100'>
      <ErrorBoundary fallback={<DefaultResultDisplay {...props} />}>
        <ResultDisplayElement {...props} />
      </ErrorBoundary>
    </div>
  )
}
